import { fetchPageSeo } from '../api';
import { createDesiredHead } from '@/entities/page-seo';
import { createHeadReconciler } from '@/shared/lib/head';

export const createPageSeoSync = () => {
  const headReconciler = createHeadReconciler();
  let latestRequestId = 0;

  return async(path) => {
    const requestId = ++latestRequestId;

    try {
      const pageSeo = await fetchPageSeo(path);

      if (requestId !== latestRequestId || !pageSeo) return;

      headReconciler.applyDesiredHead(createDesiredHead(pageSeo));
    } catch (e) {
      console.error('Failed to load page SEO', e);
    }
  };
};
